import React from "react";
import Checkbox from "components/Checkbox";
import { useTranslation } from "react-i18next";
import {
  certificationExportStore as certExportStore,
  certificationExportStore,
} from "../CertificationExportStore";
import { observer } from "mobx-react-lite";
import { buildingStore } from "store/Building/BuildingStore";
import { ExportCertificationOptions } from "api-client";
import TextInput from "components/TextInput";

const ConfigureDGNB18 = () => {
  const { t } = useTranslation();

  const { currentBuilding } = buildingStore;
  const savedValues: ExportCertificationOptions | undefined | null =
    currentBuilding?.certification_export_settings?.dgnb18;

  const handleOnChangeTGAFactor = (value: boolean) => {
    certExportStore.setAdditionalInfoFieldAndValue("TGAFactor", value);
  };

  const handleOnChangeRelevantArea = (value: string) => {
    certificationExportStore.setAdditionalInfoFieldAndValue(
      "relevantArea",
      value
    );
  };

  React.useEffect(() => {
    if (savedValues?.relevant_area) {
      handleOnChangeRelevantArea(String(savedValues.relevant_area));
    }
    handleOnChangeTGAFactor(Boolean(savedValues?.reduce_tga_factor_to_1_1));
  }, []);

  return (
    <>
      <Checkbox
        id="TGAFactor"
        checked={Boolean(certificationExportStore.additionalInfo.TGAFactor)}
        labelElement={t("certExport.reductionOfTheTGAfactor")}
        onChange={(e) => handleOnChangeTGAFactor(e.currentTarget.checked)}
        containerClassName="mb-2 pt-0"
      />
      <TextInput
        type="number"
        name="relevantArea"
        unit="m²"
        handleChange={(value) => handleOnChangeRelevantArea(value)}
        value={certificationExportStore.additionalInfo.relevantArea ?? ""}
        labelName={t("certExport.DGNBRelevantArea")}
        helper={t("certExport.DGNBRelevantAreaHelper")}
        placeholder={t("certExport.pleaseEnterArea")}
        required
      ></TextInput>
    </>
  );
};

export default observer(ConfigureDGNB18);
